export default __webpack_public_path__ + "static/media/list_main_4_1.a34fc858.png";